module.exports = __webpack_public_path__ + "img/rare_decor_image.f460d50f.png";